
<template>
  <div id="app">
    <TheHeader />
    <TheBanner />
    <TheIntro />
    <TheSection />
    <TheFaq />
    <TheVideo />
    <TheNews />
    <AdditionBtn />
    <TheFooter />
  </div>
</template>

<script>

import TheHeader from '@/components/TheHeader.vue'
import TheBanner from '@/components/TheBanner.vue'
import TheIntro from '@/components/TheIntro.vue'
import TheSection from '@/components/TheSection.vue'
import TheFaq from '@/components/TheFaq.vue'
import TheVideo from '@/components/TheVideo.vue'
import TheNews from '@/components/TheNews.vue'
import AdditionBtn from '@/components/AdditionBtn.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheBanner,
    TheIntro,
    TheSection,
    TheFaq,
    TheVideo,
    TheNews,
    AdditionBtn,
    TheFooter,
  },
  mounted() {
    let lazyImg = document.querySelectorAll('img')
    lazyImg.forEach(img => {
      img.setAttribute('loading', 'lazy')
    })
  },
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC:wght@100;300&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@500;600;700&display=swap');




html {}

body {}

.row {
  --bs-gutter-x: 0 !important;
  --bs-gutter-y: 0 !important;
}

div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a {
  color: black;
  text-decoration: none;
  display: block;
  transition: 0.3s;

}

a:hover {}

i {
  cursor: pointer;
}

body {

  line-height: 1.3rem;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}



#app {
  /* font-family: 華康古印體, '華康愛情體W5', 華康仿宋體, 宋體, 蘋果儷中黑, 華康粗黑體, 微軟正黑體, Avenir, Helvetica, Arial, sans-serif; */
  font-family: 'Noto Sans TC', 'Noto Serif TC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;


}

* {
  scroll-behavior: smooth;
}

p {
  font-size: 1.2rem !important;
  line-height: 1.8rem;
  font-family: 'Noto Sans TC';
}

h1 {
  font-size: 5rem !important;
  line-height: 5.2rem;

  font-weight: 700 !important;
  font-family: 'Noto Serif TC';
}

h2 {

  font-size: 2.8rem !important;
  text-align: center;
  line-height: 4rem;
  font-weight: 700 !important;
  font-family: 'Noto Serif TC';
}

h3 {
  font-size: 1.3rem !important;
  line-height: 3rem;
  font-weight: 400 !important;
  font-family: 'Noto Sans TC';
}

h4 {
  font-size: 1.3rem !important;
  line-height: 2rem !important;
  font-weight: 400 !important;
  font-family: 'Noto Sans TC';
}


@media screen and (max-width: 768px) {

  h1 {
    font-size: 3rem !important;
    line-height: 5.2rem;
    font-weight: 700 !important;
    font-family: 'Noto Serif TC';
  }

  h2 {
    font-size: 2rem !important;
    text-align: center;
    line-height: 4rem;
    font-weight: 700 !important;
    font-family: 'Noto Serif TC';
  }

  h3 {
    font-size: 1.1rem !important;
    line-height: 2rem !important;
    font-weight: 400 !important;
    font-family: 'Noto Sans TC';
  }

  h4 {
    font-size: 1.1rem !important;
    line-height: 2rem !important;
    font-weight: 400 !important;
    font-family: 'Noto Sans TC';
  }


}





img,
picture {
  width: 100%;
  height: auto;
}

.btn_more {
  margin-top: 3rem;
}

.fa-solid {
  color: #525b7c;
}

.layout {
  margin: auto;
}

.layout_grid {
  max-width: 1000px;
  margin: 2rem auto;
  display: grid;
}

#section_news,
#section1,
#section2,
#section3 {
  min-height: 500px;
}

@media screen and (max-width: 768px) {

  #section_news,
  #section1,
  #section2,
  #section3 {
    min-height: 500px;
  }
}

.layout_inner .layout_photo p {
  text-align: left;
  font-size: 1rem;
  padding: 1rem 3rem 2rem !important;
}

/* 4x3 縱橫比 */
.iframe-container {
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
  margin-top: 3rem;
  z-index: 1;
  width: 100%;
  min-height: 100px;
}

.iframe-container iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.iframe-container-4x3 {
  padding-top: 75%;
}

.pop {
  width: 1000px !important;
  height: 500px;
}
</style>
